define(function(require) {
    const { appendOverridesToUrl } = require('utils/authorization');
    const Cell = require('../BaseCell');
    const _ = require('underscore');

    /**
     * Renders the cell as a link
     * @param {Object} options
     * @returns column definition
     */
    const LinkCell = function(options) {
        return {
            CellClass: Cell,
            options: _.extend(
                {
                    /**
                     * @param {Number} id The row id
                     * @param {Object} row The rest of the row values
                     * @returns the string to use as the url
                     */
                    url: function(id, row) {
                        return id;
                    },
                    type: 'string',
                    className: 'dt-body-left text-left',
                    onDisplay: function(data, type, row, meta, translatedValue, rowModel = undefined) {
                        // If no url is found, treat is as normal text
                        const url = this.url(row.id, row);

                        if (url) {
                            return _.template(/* template */ `
                                    <a  data-toggle="tooltip" title="<%- tooltip %>" href="<%= url %>" class="data-grid__cell--link">
                                        <div ><%- data %></div>
                                    </a>`)({
                                data: translatedValue,
                                url: appendOverridesToUrl(url),
                                // Show a tooltip if it might be truncated
                                tooltip: translatedValue && translatedValue.length > 50 ? translatedValue : ''
                            });
                        } else {
                            return translatedValue;
                        }
                    }
                },
                options
            )
        };
    };
    return LinkCell;
});
